import { Component, OnInit, ViewChild, AfterViewInit, Output, EventEmitter, Input, ElementRef } from '@angular/core';
import { notificationAlertModel } from './notificationAlert.model';
import { FormComponent } from '../../../form/form.component';
import { ServiceStock } from '../../../service-stock.service';
import { NotificationService } from 'src/app/notification.service';

const customCss: string = '';

@Component({
    selector: 'app-notificationAlert',
    templateUrl: './notificationAlert.component.html'
})
export class notificationAlertComponent extends FormComponent implements OnInit {
   
    constructor(services: ServiceStock, private notifyService: NotificationService) {
        super(services);
        this.value = new notificationAlertModel();
        this.componentCode = 'notificationAlert';
    }
    
    ngOnInit() {
    }
    ngOnDestroy() {
    }
 
}